import React from 'react';

import styles from './input-container.module.scss';

export default class InputContainer extends React.PureComponent {
	render() {
		return (
			<div className="input-container-wrapper">
				<div className={`row-items`}>
					{!this.props.labelAfterInput && (
						<label htmlFor={this.props.id} className={styles.label}>
							{this.props.label}{' '}
							{this.props.helpText && <span className={styles.helpText}>({this.props.helpText})</span>}
						</label>
					)}
					{this.props.body}

					{this.props.labelAfterInput && (
						<label htmlFor={this.props.id} className={styles.label}>
							{this.props.label}{' '}
							{this.props.helpText && <span className={styles.helpText}>({this.props.helpText})</span>}
						</label>
					)}
				</div>

				{this.props.validationError && (
					<div className="alert alert-danger" role="alert">
						{this.props.validationError.props.children}
					</div>
				)}
			</div>
		);
	}
}
